/* =================== HEADER FULL =================== */
jQuery(document).ready(function ($) {
  if (!isMobileX(1119)) {
    const header = $(".menu-vertical");
    if (header.length > 0) {
      function toggleHeaderFull() {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 1000) {
          header.addClass("fixed");
        } else {
          header.removeClass("fixed");
        }
      }

      toggleHeaderFull();
      $(window).on(
        "scroll",
        debounce(function () {
          toggleHeaderFull();
        }, 10)
      );
    }
  }
});

jQuery(window).scroll(function () {
  var $sections = $(".menu-scroll");
  $sections.each(function (i, el) {
    var top = $(el).offset().top - 160;
    var bottom = top + $(el).height();
    var scroll = $(window).scrollTop();
    var id = $(el).attr("id");
    if (scroll > top && scroll < bottom) {
      $("a.active").removeClass("active");
      $('a[href="#' + id + '"]').addClass("active");
    }
  });
});

$("#lista-menu").on("click", "a", function (event) {
  event.preventDefault();
  var id = $(this).attr("href"),
    top = $(id).offset().top;
  $("body,html").animate({ scrollTop: top }, 800);
});
